import React from 'react';
import { ModalInfo } from './ModalInfo';
import { ModalInfoWithDate } from './ModalInfoWithDate';
import { ModalInfoWithEmail } from './ModalInfoWithEmail';
import ModalSpinner from './ModalSpinner';
import Resume from './Resume';
import { Text, Box } from '@chakra-ui/react';
import ModalPrint from './ModalPrint';
import menuUtils from '../utils/menu-utils';
import CashierChange from './CashierChange';
const domain =
window.location.hostname === 'localhost'
  ? 'http://localhost:3000'
  : 'https://' + window.location.hostname;

function Menu2Modals({
  isLoading,
  progress,
  showModalPriorityAccess,
  setShowModalPriorityAccess,
  showModalSelectDate,
  setShowModalSelectDate,
  appSettings,
  selectedDate,
  setSelectedDate,
  showModalAppIsClosed,
  setShowModalAppIsClosed,
  reset,
  navigate,
  showModalBuyCustomer,
  setShowModalBuyCustomer,
  checkoutUrl,
  showModalConfirmOrderCustomer,
  setShowModalConfirmOrderCustomer,
  showModalConfirmOrderCashier,
  setShowModalConfirmOrderCashier,
  showModalResultCashier,
  setShowModalResultCashier,
  modalCashierText,
  setModalCashierText,
  cashierOrderId,
  setCashierOrderId,
  menu,
  handleCustomerOrderConfirm,
  handleCashierOrderConfirm,
  paymentType,
  formatDate,
  formatDateWithTime,
  pranzoCena,
}) {
  const total = menuUtils.total(menu);

  // paymentType values:
  // - 'cash' => contanti
  // - 'card' => carta
  // - 'free' => omaggio
  // - null/undefined => non selezionato
  const paymentTypeLabel = (() => {
    switch (paymentType) {
      case 'cash':
        return 'CONTANTI';
      case 'card':
        return 'CARTA';
      case 'free':
        return 'OMAGGIO';
      case null:
      case undefined:
        return '—';
      default:
        return 'SCONOSCIUTO';
    }
  })();

  return (
    <>
      {/* MODAL LOADER */}
      <ModalSpinner isOpen={isLoading} progress={progress} />

      {/* MODAL PRIORITY */}
      <ModalInfoWithEmail
        isOpen={showModalPriorityAccess}
        title='Accedi al menù'
        body='Inserisci una email che hai già usato per ordinare in questa data.'
        onCancel={() => {
          setShowModalSelectDate(true);
        }}
        selectedDate={selectedDate}
        onClose={(isAllowed) => {
          if (isAllowed) {
            setShowModalPriorityAccess(false);
          }
        }}
      />

      {/* MODAL SELEZIONA DATA*/}
      <ModalInfoWithDate
        isOpen={showModalSelectDate}
        title='Seleziona la data per il tuo ordine'
        eventDates={appSettings.eventDates}
        showLunchDinner={appSettings.showLunchDinner}
        onClose={async (selectedDate) => {
          setSelectedDate(selectedDate);
          setShowModalSelectDate(false);
        }}
      >
        {/* Qui puoi inserire ListOfPriorityDates se necessario */}
      </ModalInfoWithDate>

      {/* MODAL APP IS CLOSED */}
      <ModalInfo
        title='Servizio non disponibile'
        body='Il servizio di ordinazioni non è aperto al pubblico.'
        isOpen={showModalAppIsClosed}
        onClose={() => {
          setShowModalAppIsClosed(false);
          reset();
          navigate('/');
        }}
      />

      {/* MODAL APERTURA STRIPE */}
      {checkoutUrl && (
        <ModalInfo
          title='Ordina'
          body={'Apri una pagina sicura per il pagamento.'}
          isOpen={showModalBuyCustomer}
          url={checkoutUrl}
          onClose={async () => {
            setShowModalBuyCustomer(false);
          }}
        />
      )}

      {/* MODAL CONFERMA ORDINE UTENTE*/}
      <ModalInfo
        isOpen={showModalConfirmOrderCustomer}
        title='Conferma ordine'
        body='Stai per effettuare questo ordine.'
        onCancel={() => {
          setShowModalConfirmOrderCustomer(false);
        }}
        onClose={handleCustomerOrderConfirm}
      >
        <Resume menu={menu} />
      </ModalInfo>

      {/* RICHIESTA CONFERMA ORDINE - CASHIER */}
      <ModalInfo
        isOpen={showModalConfirmOrderCashier}
        title='Inserisci Ordine'
        body={
          <Box>
            <Box display='flex' alignItems='center' gap={2} mb={2}>
              <Text as='span' fontWeight='bold' fontSize='xl'>Tipo di pagamento</Text>
              <Text as='span' fontWeight='bold' fontSize='xl' color='gold'>
                {paymentTypeLabel}
              </Text>
            </Box>
            <Box display='flex' alignItems='center' gap={2} mb={2}>
              <Text as='span' fontWeight='bold' fontSize='xl'>Per </Text>
              <Text as='span' fontWeight='bold' fontSize='xl' color='gold'>
                {appSettings.showLunchDinner
                  ? `${formatDate(selectedDate)} (${pranzoCena(selectedDate)})`
                  : formatDateWithTime(selectedDate)}
              </Text>
            </Box>
            <Box display='flex' alignItems='center' gap={2} mb={2}>
              <Text as='span' fontWeight='bold' fontSize='xl'>Totale</Text>
              {paymentType === 'free' ? (
                <Box display='flex' alignItems='center' gap={2}>
                  <Text as='span' fontWeight='bold' fontSize='xl' color='gold' textDecoration='line-through'>
                    {total.toFixed(2)}€
                  </Text>
                  <Text as='span' fontWeight='bold' fontSize='xl' color='gold'>
                    0.00 €
                  </Text>
                </Box>
              ) : (
                <Text as='span' fontWeight='bold' fontSize='xl' color='gold'>
                  {total.toFixed(2)}€
                </Text>
              )}
            </Box>
            {paymentType === 'cash' && (
              <CashierChange total={total} />
            )}
          </Box>
        }
        onCancel={() => {
          setShowModalConfirmOrderCashier(false);
        }}
        onClose={() => handleCashierOrderConfirm(paymentType)}
      >
        <Resume menu={menu} />
      </ModalInfo>

      
     {/* MODAL RENDICONTA RESULT - CASHIER*/}
        <ModalPrint
          isOpen={showModalResultCashier}
          onClose={() => {
            setShowModalResultCashier(false);
            setModalCashierText('');
            setCashierOrderId('');
          }}
          modalCashierText={modalCashierText}
          orderId={cashierOrderId}
          url={`${domain}/order/${cashierOrderId}`}
        />
      
    </>
  );
}

export default Menu2Modals;
